// import swiper
// import Swiper from 'swiper/bundle';
// import 'swiper/css/bundle';

var swiper = new Swiper(".slider-1", {
    spaceBetween: 2,
    loop: true,
    loopedSlides: 2,
    speed: 6000,
    autoplay: {
        delay: 1,
        disableOnInteraction: false,
    },
    breakpoints: {
        575: {
            slidesPerView: 3,
        },
        // 992: {
        //     slidesPerView: 4,
        // }
    }
});

var swiper = new Swiper(".slider-2", {
    spaceBetween: 2,
    loop: true,
    loopedSlides: 2,
    speed: 6000,
    autoplay: {
        delay: 1,
        disableOnInteraction: false,
    },
    breakpoints: {
        575: {
            slidesPerView: 3,
        },
        // 992: {
        //     slidesPerView: 4,
        // }
    }
});
